import {Base} from './base.model';
import {TipoAttributo} from './tipoattributo.enum';
import {TableRow} from './table-row.model';
import {TableRowValue} from './table-row-value.model';

export abstract class Attributo extends Base   {

  constructor(public id: number,
              public nome: string,
              public tipo: TipoAttributo) {
    super(id);
  }

  public static getTableKeys() {
    return ['id', 'nome', 'tipo'];
  }

  public getLabel() {
    return this.nome;
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('id', new TableRowValue(this.id, null));
    rowValues.set('nome', new TableRowValue(this.nome, null));
    rowValues.set('tipo', new TableRowValue(this.tipo ? this.tipo.getEnumValue() : null, null, true));
    return new TableRow(this, rowValues);
  }

}
